import React, { useEffect, useState } from "react";
import { Dropdown, Space, Drawer } from "antd";
import "../styles/topbar.css";
import profileImage from "../assets/topbar/profile-logo.svg";
import Hamburger from "../assets/topbar/hamburger.svg";
import { Link, useNavigate } from "react-router-dom";
import Icon from "../assets/Icon";
import DriverButton from "./DriverButton";

import { User2, X } from "lucide-react";
import getNavItems from "../constants/NavItems";
import SidebarCreditsCard from "./SidebarCreditsCard";
// import DriverButton from "./driverjs/DriverButton";

export default function Topbar(props) {
  const navigate = useNavigate();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem("userData")),
  );

  useEffect(() => {
    setUserData(JSON.parse(localStorage.getItem("userData")));
  }, [props.userDataChanged]);

  const handleDrawerToggle = () => {
    setDrawerVisible(!drawerVisible);
  };
  const closeDrawer = () => {
    setDrawerVisible(false);
  };
  const logoutHandle = () => {
    localStorage.clear();
    // window.location.href = "/login";
    const currentUrl = window.location.href;

    if (currentUrl.includes("dev")) {
      // Redirect to dev environment access page
      window.location.href = "https://dev.jobdrona.com/";
    } else if (currentUrl.includes("localhost")) {
      // Redirect to dev environment access page for localhost
      window.location.href = "https://dev.jobdrona.com/";
    } else {
      // Redirect to production environment access page
      window.location.href = "https://jobdrona.com/";
    }
  };

  const profileItems = [
    {
      label: (
        <Link to="/settings">
          <span className="text-[1rem] px-1 flex items-center gap-[0.6rem]">
            {/* <UserOutlined style={{ fontSize: "19px", color: "#475467" }} /> */}
            <User2 color="#475467" size={21} />
            <span>Profile</span>
          </span>
        </Link>
      ),
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: (
        <span
          className="text-[1rem] px-1 flex items-center gap-[0.6rem]"
          onClick={logoutHandle}
        >
          <Icon type="logout" width={18} height={18} />
          <span>Logout</span>
        </span>
      ),
      key: "1",
    },
  ];

  let mobileLowerViews = [
    {
      display: "Account Settings",
      key: "settings",
      path: "/settings",
    },
  ];

  const mobileViews = getNavItems(props.userRole);

  const drawerFooter = (
    <div className="w-[100%] py-0 my-2 flex justify-between itmes-center px-4">
      <div>
        <p className="p-0 m-0 leading-4  mb-1 w-full font-semibold text-base text-[#344054] ">
          {userData?.firstName} {userData?.lastName}
        </p>
      </div>
      <div className="items-center flex cursor-pointer" onClick={logoutHandle}>
        <Icon type="logout" width={21} height={21} />
      </div>
    </div>
  );
  return (
    <>
      <div className="w-full ">
        {" "}
        <div className="topbar w-full px-3 py-2 flex items-center justify-between gap-2">
          <div className="page-title flex gap-[.7rem] items-center">
            {!props.noNavigate && (
              <span
                className="pageBackBtn text-[#101828] font-semibold text-[1rem]"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (props?.newTitle === "Edit Resume") {
                    navigate(`/cv-optimizer?tab=allResumes`);
                  } else {
                    navigate(-1);
                  }
                }}
              >
                <Icon type="left-arrow-icon" />
              </span>
            )}

            <span className="text-[#101828] font-semibold text-base break-words">
              {props.newTitle || "Proctor++"}
            </span>
          </div>

          <div className="hpp-logo">
            <Link className="inline-block" to="/dashboard">
              <Icon type="jobdrona-logo" width={50} height={32} />
            </Link>
          </div>

          <div className="topbar-right-section w-[400px]">
            {/* <QuestionCircleOutlined
              style={{ fontSize: "21px" }}
              className="mr-6 mt-[2px]"
            /> */}
            {/* <Badge count={5} className="mr-1" size="small" offset={[-4, 5]}>
              <BellOutlined style={{ fontSize: "22px" }} />
            </Badge> */}
            {/* {props.driverFlag && <DriverButton {...props} />} */}
            <div className="mr-3 profile-section">
              <img
                src={profileImage}
                alt="Avatar"
                width={27}
                style={
                  {
                    // background: "lightgray",
                    // margin: "0px 15px 0 20px",
                  }
                }
              />
            </div>
            <div className=" p-0 m-0 profile-section">
              <Dropdown
                overlayClassName="custom-dropdown-menu"
                className="cursor-pointer"
                menu={{
                  items: profileItems,
                }}
                trigger={["click"]}
              >
                <Space className="text-[#101828] hover:text-amber-500 transition-all duration-200">
                  <p className="leading-[1.1rem] w-full font-semibold text-[.94rem]  break-words">
                    {userData?.firstName} {userData?.lastName}
                  </p>
                  <p>
                    {" "}
                    <svg
                      width="12"
                      height="8"
                      viewBox="0 0 10 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clip-rule="evenodd"
                        d="M9.29172 0.335937C9.71097 0.335937 9.94406 0.820903 9.68215 1.14829L5.38913 6.51456C5.18897 6.76477 4.80843 6.76477 4.60826 6.51456L0.315242 1.14828C0.0533365 0.820903 0.286424 0.335937 0.705677 0.335937L9.29172 0.335937Z"
                        fill="currentColor"
                      />
                    </svg>
                  </p>
                </Space>
              </Dropdown>
            </div>
            <img
              src={Hamburger}
              alt=""
              className="hamburger-icon"
              style={{ fontSize: "24px", cursor: "pointer" }}
              onClick={handleDrawerToggle}
            />
          </div>
        </div>
      </div>

      <Drawer
        title={
          <div className="hpp-logo">
            <Link className="inline-block" to="/dashboard">
              <Icon type="jobdrona-logo" width={50} height={32} />
            </Link>
          </div>
        }
        placement="right"
        onClose={handleDrawerToggle}
        open={drawerVisible}
        closeIcon={false}
        extra={
          <Space>
            <X className="cursor-pointer" onClick={closeDrawer} />
          </Space>
        }
        footer={drawerFooter}
      >
        <div className="mt-5">
          {mobileViews.map((view, index) => {
            const IconComp = view.icon;
            return (
              <Link to={view.path} key={index}>
                <div
                  className={`mobile-view-wrapper ${view.className} flex items-center gap-[12px]`}
                  data-status={props.activePage === view.key}
                >
                  <div>
                    <IconComp
                      size={21}
                      strokeWidth={2}
                      className="transition-transform duration-150 group-hover:scale-110"
                    />
                  </div>
                  <div className={`view`}>{view.display}</div>
                </div>
              </Link>
            );
          })}
        </div>
        <div className="mobile-lower-section">
          {mobileLowerViews.map((view, index) => {
            return (
              <div>
                {/* {<SidebarCreditsCard />} */}
                <Link to={view.path} key={index}>
                  <div
                    className={`mobile-view-wrapper my-2 flex items-center gap-[11px]`}
                    data-status={props.activePage === view.key}
                  >
                    <Icon
                      width={21}
                      height={21}
                      type={`drawer-${view.key}-logo`}
                      color="black"
                    />
                    <div className="view">{view.display}</div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </Drawer>
    </>
  );
}
